module.exports = __webpack_public_path__ + "media/marketing_campaigns/triggers-a7673265.svg";